/**
 * goToZapper action.
 */
import Pages from '@pages';
import { enableParental } from '../../store/slices/user.slice';
import { pushRoute } from '../../store/thunks/route.thunk';
import { store } from '../../store/store';

/**
 * Function to redirect to the zapper page.
 */
export default function goToZapper() {
  store.dispatch(enableParental());
  store.dispatch(
    pushRoute({
      route: {
        Page: Pages.ZAPPER,
        overwrite: true,
      },
    })
  );
}
